import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

// core components
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";

// @material-ui/icons
import { Close } from "components/MaterialSymbol/MaterialIcons";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";

const style = (theme) => ({
    cardTitle,
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px",
        "& small": {
            fontSize: "80%",
            fontWeight: "400",
        },
    },
    plainHeader: {
        color: "#18324b",
        margin: "0 !important",
        padding: "0 20px 18px !important",
        "& h4": {
            color: "#18324b",
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: 1.5,
            margin: "0 !important",
        },
    },
    ...modalStyle(theme),
});

const useStyles = makeStyles(style);


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const DEFAULT_MAX_WIDTH = 'lg';

export default function Modal({
    open = false,
    maxWidth = DEFAULT_MAX_WIDTH,
    modalTitle = '',
    plainHeader = false,
    handleClose = () => { },
    children,
    ...otherProps
}) {
    const classes = useStyles();

    return (
        <Dialog
            {...otherProps}
            classes={{
                root: classes.center + " " + classes.modalRoot,
            }}
            maxWidth={maxWidth}
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => handleClose(false)}
        >
            <DialogContent
                id="classic-modal-slide-description"
                className={classes.modalBody}
            >
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader
                                color={plainHeader ? undefined : "rose"}
                                icon={!plainHeader}
                                plain={plainHeader}
                                className={plainHeader ? classes.plainHeader : undefined}
                            >
                                {/*<CardIcon color="rose">
                                    <Edit />
                                </CardIcon>*/}
                                <div
                                    style={{
                                        alignItems: "center",
                                        display: "flex",
                                        gap: "12px",
                                        justifyContent: "space-between",
                                        width: "100%",
                                    }}
                                >
                                    <h4
                                        className={classes.cardIconTitle}
                                        style={{ marginRight: "auto", minWidth: 0 }}
                                    >
                                        {modalTitle}
                                    </h4>
                                    <Button
                                        justIcon
                                        key="close"
                                        aria-label="Close"
                                        color="transparent"
                                        onClick={() => handleClose(false)}
                                        style={{
                                            color: '#969696',
                                            flex: "0 0 auto",
                                            marginLeft: 0,
                                        }}
                                    >
                                        <Close className={classes.modalClose} />
                                    </Button>
                                </div>
                            </CardHeader>
                            <CardBody>
                                {children}
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </DialogContent>
        </Dialog>
    );
}
